import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram, yelp, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#AF253B" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Bene-Sushi-Restaurant-211867315536629/"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={facebook}
                alt="Haku Sushi Facebook"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/hakusushi.van"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={instagram}
                alt="Haku Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#AF253B" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.facebook.com/Bene-Sushi-Restaurant-211867315536629/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Haku Sushi Facebook"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/hakusushi.van"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Haku Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
